import Vue from 'vue';
import Vuex from 'vuex';
import createCache from 'vuex-cache';

import app from '@motionelements/core/src/store/modules/app.js'; // migrate site to app
import browser from '@motionelements/core/src/store/modules/browser.js';
import user from '@motionelements/core/src/store/modules/user';
import route from '@motionelements/core/src/store/modules/route';
import notification from '@motionelements/core/src/store/modules/notification';
import modal from '@motionelements/core/src/store/modules/modal';
import cart from '@motionelements/core/src/store/modules/cart';
import blocker from '@motionelements/core/src/store/modules/blocker';
import favorites from '@motionelements/core/src/store/modules/favorites';
import audioPlayer from '@motionelements/core/src/store/modules/audioPlayer.js';
import product from '@motionelements/core/src/store/modules/product.js';
import agencies from '@motionelements/core/src/store/modules/agencies.js';
// import site from '@motionelements/core/src/store/modules/site.js'; // @deprecating
import payout from '@motionelements/core/src/store/modules/payout.js';

import experiment from '@motionelements/core/src/store/modules/experiment';

import {
  persistElementUpload,
  persistExperiment,
  persistMetadataImport,
  persistCart,
  persistFavorites,
  persistNavbar,
} from '@/store/persists';

import cookie from '@/store/modules/cookie';
// import site from './modules/site';
// import member from './modules/member';

// import search from './modules/search/search';

import artistProfilePage from '@/store/modules/artist/profile-page.js';
import artistDashboard from '@/store/modules/artist/dashboard.js';
import artistCreatorList from '@/store/modules/artist/creator-list.js';
import artistReleaseList from '@/store/modules/artist/release-list.js';
import artistElementList from '@/store/modules/artist/element-list.js';
import artistElementEdit from '@/store/modules/artist/element-edit.js';
import artistCollectionEdit from '@/store/modules/artist/collection-edit.js';
import artistCollectionList from '@/store/modules/artist/collection-list.js';
import artistSales from '@/store/modules/artist/sales.js';
import artistMetadataImport from '@/store/modules/artist/metadata/metadata-import';
import artistElementUpload from '@/store/modules/artist/element-upload';

import artistTemplate from '@/store/modules/artist/template';
import artistTemplateList from '@/store/modules/artist/template-list.js';
import artistMetadataTemplates from '@/store/modules/artist/metadata/metadata-templates.js';

const isProduction = process.env.VUE_APP_ENV === 'production';

let plugins = [
  persistElementUpload.plugin,
  persistExperiment.plugin,
  persistMetadataImport.plugin,
  persistCart.plugin,
  persistFavorites.plugin,
  persistNavbar.plugin,
  createCache(),
];

if (!isProduction) {
  plugins = [...plugins, ...[
    // additional plugins for staging / dev
  ]];
}

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    // CORE modules
    app,
    browser,
    cookie,
    experiment,
    modal,
    notification,
    user,
    agencies,

    // OTHER modules
    cart,
    route,
    blocker,
    favorites,
    audioPlayer,
    product,
    artistSales,
    artistProfilePage,
    artistDashboard,
    artistCreatorList,
    artistReleaseList,
    artistElementList,
    artistElementEdit,
    artistCollectionList,
    artistCollectionEdit,
    artistTemplate,
    artistTemplateList,
    artistMetadataTemplates,
    artistMetadataImport,
    artistElementUpload,
    //
    payout,
  },
  plugins: plugins,
});
